import { UserAuthToken } from '../api/ApiClient';

export const setUserAuthTokens = (userAuthTokens: UserAuthToken[]) => localStorage.setItem('userAuthTokens', JSON.stringify(userAuthTokens));

export const clearUserAuthTokens = () => localStorage.removeItem('userAuthTokens');

export const getUserAuthTokens = () => {
    const localData = localStorage.getItem('userAuthTokens');

    if (localData) {
        return JSON.parse(localData) as UserAuthToken[];
    }

    return null;
};
